export default function BtnDeleteValue({ device, onDelete, onClose }) {
  return (
    <>
      <button
        class="button-3"
        style={{ padding: '5px 10px', display: 'flex', alignItems: 'center' }}
        data-fancybox data-src="#dialog-content"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '5px' }}>
          <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z" fill="currentColor" />
        </svg>
        Удалить предыдущее показание
      </button>

      <div id="dialog-content" style="display:none; max-width:500px; padding: 25px;">
        <h2 class="debt-table__title-2">Удалить предыдущее показание</h2>
        <br />
        <p>
          Прибор учета № {device.serialNumber}<br />
          Показание: {device.meterReading}<br />
          Дата передачи показания: {device.dateMeterReading}<br />
          Источник показаний: {device.valueType}<br />
        </p>
        <br /><br />
        <div style="display: flex; flex-direction: column;">
          <button class="button-primary" style="padding: 10px; min-width: 80px;" onClick={onDelete}>Удалить</button>
          <button class="button-secondary" style="padding: 10px; min-width: 80px;" onClick={onClose}>Отмена</button>
        </div>
      </div>
    </>
  );
}
